module.exports = __webpack_public_path__ + "static/media/Bus.5f9667b4.png";